"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCache = createCache;
function createCache(maxSize) {
  var storage = new Map();
  var sizeLimit = maxSize - 1;
  function removeLeastRecentlyUsedEntries() {
    if (storage.size > sizeLimit) {
      var orderedList = Array.from(storage).sort(function (a, b) {
        return b[1].time - a[1].time;
      });
      for (var i = orderedList.length - 1; i >= sizeLimit; i--) {
        storage["delete"](orderedList[i][0]);
      }
    }
  }
  return {
    get: function get(key) {
      if (storage.has(key)) {
        var item = storage.get(key);
        item.time = Date.now();
        return item.value;
      }
    },
    set: function set(key, value) {
      removeLeastRecentlyUsedEntries();
      storage.set(key, {
        time: Date.now(),
        value: value
      });
    },
    clear: function clear() {
      storage.clear();
    },
    "delete": function _delete(key) {
      storage["delete"](key);
    }
  };
}